import { daysToExpiration } from '../../../../../utils/daysToExpiration';
import type { FormSegment } from '../../../../types';
import { isSegmentExpired, isSegmentSoonToExpire } from '../../../../utils/hasExpiredSegments';
import { getSegmentAlertProps } from './getSegmentAlertProps';

/**
 * Expiration alert props for a segment, using the same rules as the criteria tab and its sorting.
 */
export const getSegmentExpirationAlertProps = (segment: FormSegment) => {
  const isExpired = isSegmentExpired(segment);
  const isSoonToExpire = !isExpired && isSegmentSoonToExpire(segment);

  return getSegmentAlertProps(false, isExpired, isSoonToExpire, daysToExpiration(segment.expiration_date) ?? 0);
};
